import React from 'react';
import { Truck, Bus, Caravan, Container, Tent, Mountain, Car } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { VehicleCategory } from '../../types';

const CATEGORY_ICONS: Record<VehicleCategory, React.ElementType> = {
  motorhome: Truck,
  campervan: Bus,
  caravan: Caravan,
  camper_trailer: Container,
  rooftent: Tent,
  offroad: Mountain,
  car: Car,
};

interface VehicleBadgeProps {
  category: VehicleCategory;
  length?: number;
  is4wd?: boolean;
  compact?: boolean;
}

export default function VehicleBadge({ category, length, is4wd, compact }: VehicleBadgeProps) {
  const { t } = useTranslation();
  const Icon = CATEGORY_ICONS[category] || Truck;

  return (
    <span className="inline-flex items-center gap-1 bg-orange-500/8 border border-orange-500/20 text-orange-400 text-4xs font-black uppercase tracking-widest rounded-full px-2 py-0.5">
      <Icon size={9} />
      {!compact && <span>{t(`profile.garage.categories.${category}`)}</span>}
      {length && !compact && <span className="opacity-60">{Math.round(length / 100)}m</span>}
      {is4wd && <span className="text-amber-400">4WD</span>}
    </span>
  );
}
